import { render, staticRenderFns } from "./AIPlugins.vue?vue&type=template&id=683909c8&scoped=true"
import script from "./AIPlugins.vue?vue&type=script&lang=js"
export * from "./AIPlugins.vue?vue&type=script&lang=js"
import style0 from "./AIPlugins.vue?vue&type=style&index=0&id=683909c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683909c8",
  null
  
)

export default component.exports